import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { AdvanceFilter, StoreFilterParams } from '../../common/types'
import { defaultPageParams } from '../constants'

const defaultParams = [
  { title: 'Created Date', slug: 'job_date', isChecked: false },
]

export const useReportJobFilterStore = create<ReportJobFilterStoreType>()(
  persist(
    (set) => ({
      pageParams: defaultPageParams,
      advanceFilter: {
        filterParams: defaultParams,
        isDetailed: true,
      },
      selectedRows: [],

      setAdvanceFilter: (data) => set(() => ({ advanceFilter: data })),
      clearSelectedRows: () => set({ selectedRows: [] }),
      setPageParams: (data) => set(() => ({ pageParams: data })),
      clearAdvanceFilter: () =>
        set(() => ({
          advanceFilter: {
            filterParams: defaultParams?.map((item) => ({
              ...item,
              isChecked: false,
            })),
            isDetailed: true,
          },
        })),
      setSelectedRows: (data) => set(() => ({ selectedRows: data })),
      clearReportJobFilter: (key) =>
        set((state) => ({
          pageParams: key
            ? { ...defaultPageParams, search: state?.pageParams?.search }
            : defaultPageParams,
        })),
      resetStore: () =>
        set(() => ({
          pageParams: defaultPageParams,
          advanceFilter: {
            filterParams: defaultParams,
            isDetailed: true,
          },
          selectedRows: [],
          search: '',
        })),
    }),
    { name: 'fit__report_job_store' }
  )
)

type ReportJobFilterStoreType = {
  pageParams: StoreFilterParams
  selectedRows?: (number | string)[]
  advanceFilter: AdvanceFilter
  setSelectedRows: (data: (number | string)[]) => void
  setPageParams: (data: StoreFilterParams) => void
  setAdvanceFilter: (data: AdvanceFilter) => void
  clearReportJobFilter: (key?: string) => void
  clearSelectedRows: () => void
  clearAdvanceFilter: () => void
  resetStore: () => void
}
